// import 'polyfills'
import { isProduction } from 'helpers'
import { gsap, ScrollTrigger } from 'gsap/all'
import { Accordion, Hero, Tabs, SubNav, Navigation, OverviewListBlock } from 'components'

import overlayGrid from 'utility/overlayGrid'

gsap.registerPlugin(ScrollTrigger)

const app = {
  init(): void {
    // * Components...
    Accordion.init()
    Tabs.init()
    SubNav.init()
    Navigation.init()

    if (Hero.el.hero) Hero.init()
    if (OverviewListBlock.el.block) OverviewListBlock.init()

    // * Loaded last...
    !isProduction && overlayGrid.init()
  },
}

document.addEventListener('DOMContentLoaded', (): void => {
  setTimeout((): void => {
    document.querySelector('.body').classList.remove('preload')
  }, 100)

  app.init()
})
